import React, { createContext, useContext, useState, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';

interface BoardListContextType {
  refreshTrigger: number;
  refreshBoardList: () => void;
}

const BoardListContext = createContext<BoardListContextType>({
  refreshTrigger: 0,
  refreshBoardList: () => {},
});

export const BoardListProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const queryClient = useQueryClient();

  const refreshBoardList = useCallback(() => {
    // TanStack Queryのボード関連クエリを全て無効化
    queryClient.invalidateQueries({
      predicate: (query) => {
        const queryKey = query.queryKey as string[];
        const isBoardsQuery = queryKey[0] === 'boards' && queryKey[1] === 'list';
        return isBoardsQuery;
      }
    });

    // より確実にするため、キャッシュを完全にクリア
    queryClient.removeQueries({
      predicate: (query) => {
        const queryKey = query.queryKey as string[];
        return queryKey[0] === 'boards' && queryKey[1] === 'list';
      }
    });

    setRefreshTrigger(prev => {
      const newValue = prev + 1;
      return newValue;
    });
  }, [queryClient]);

  const value = {
    refreshTrigger,
    refreshBoardList,
  };

  return (
    <BoardListContext.Provider value={value}>
      {children}
    </BoardListContext.Provider>
  );
};

export const useBoardListContext = () => useContext(BoardListContext); 